import UnclaimedDraftEmbeddedSigning from "components/lib/Shared/ESignature/UnclaimedDraftEmbeddedSigning";
import { useDispatch, useSelector } from "react-redux";
import { convertOfficialDetailsToSignerDetails } from "utils/esignature";
import { updateCompanyAsync } from "state/slices/company";

const SingleStep = ({ handleBackBtn }) => {
  const companyOfficials = useSelector(
    (state) => state.companyOfficialsSlice.companyOfficials.items
  );
  const currentUser = useSelector((state) => state.userSlice);
  const { company } = useSelector((state) => state.companySlice);
  const dispatch = useDispatch();
  const applicant = convertOfficialDetailsToSignerDetails(company?.createdBy);
  let signers = companyOfficials.map((details) =>
    convertOfficialDetailsToSignerDetails(details)
  );

  const isApplicantOfficial = signers.find(
    (signer) =>
      signer.name === applicant.name &&
      signer.emailAddress === applicant.emailAddress
  );

  if (!isApplicantOfficial) {
    signers = [applicant, ...signers];
  }

  const allForms = Object.keys(company?.preSignedBusinessDocuments)
    .map((key) => key)
    .reverse();

  const fileUrls = allForms.map(
    (form) =>
      `${process.env.REACT_APP_IMAGE_BASE_URL}/images/${company.preSignedBusinessDocuments[form]}`
  );

  const updateCompanyStatusToSignature = () => {
    dispatch(
      updateCompanyAsync({
        id: company._id,
        data: { status: "Signature", agreeToSubmit: true },
      })
    );
  };

  const functionsToCall = [updateCompanyStatusToSignature, handleBackBtn];

  const metadata = {
    fileNames: allForms,
    isBothDirectorsAndShareholdersEmail: true,
    companyId: company._id,
    // user: currentUser,
  };

  return (
    <div>
      <UnclaimedDraftEmbeddedSigning
        signers={signers}
        fileUrls={fileUrls}
        metadata={metadata}
        functionsToCall={functionsToCall}
      />
    </div>
  );
};

export default SingleStep;
